import React from "react";
import { Box, Typography } from "@mui/material";

type CardType = {
      heading: string;
      leftHeading?: string;
      leftValue?: string;
      leftUnit?: string;
      rightHeading?: string;
      rightValue?: string;
      rightUnit?: string;
      percentage?: number;
      showProgressBar?: boolean;
      rightHeadingLabel?: boolean;
      rightValueLabel?: boolean;
};
type AnalyticsCardContentsProps = {
  cardsData?: CardType[];
  analyticsData?: any;
  activeTab?: string;
  subTab?: string;
};

const AnalyticsCardContents = (props: AnalyticsCardContentsProps) => {
  const { cardsData=[], analyticsData=[], activeTab='', subTab='' } = props;
  const cardContent = cardsData.length>0 ? cardsData : analyticsData?.[activeTab]?.[subTab]?.topCard?.cardContent;

  if (!cardContent || !cardContent.length) return null;

  const cardCount = cardContent.length;
  const gap = 16; 
  const totalGap = (cardCount - 1) * gap;
  const cardWidth = `calc((100% - ${totalGap}px) / ${cardCount})`;

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: `${gap}px`, width: "100%" }}>
      {cardContent.map((cardObj, index) => {

        const card = Object.values(cardObj)[0] as CardType;

        const safePercentage = (() => {
          if (typeof card.rightHeading === "string" && card.rightHeading.includes("%")) {
            return parseFloat(card.rightHeading.replace("%", "").trim()) || 0;
          }
          return typeof card.percentage === "number" ? card.percentage : 0;
        })();

        return (
          <Box
            key={index}
            sx={{
              width: {
                xs: "100%",
                sm: "calc(50% - 8px)",
                md: cardWidth,
              },
              boxSizing: "border-box",
            }}
          >

            <Box
              sx={{
                backgroundColor: "#F9F9F9",
                borderRadius: "10px",
                padding: "7px 11px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography sx={{ fontSize: "22px", fontWeight: 600, color: "#45464E", fontFamily: "Inter" }}>
                  {card.heading}
                </Typography>
                <Typography
                  sx={{ fontSize: "22px", fontWeight: 600, color: "#45464E", fontFamily: "Inter" }}
                >
                  {card?.rightHeading !== undefined && card?.rightHeading !== null
                    ? <>
                      <span>{String(card.rightHeading)}</span>
                      {/* <span className="analytics-cards-label">{card?.rightHeadingLabel}</span> */}
                    </>
                    : ""}
                </Typography>
              </Box>

              {card.showProgressBar && typeof safePercentage === "number" && (
                <Box sx={{ height: "5px", backgroundColor: "#D6DAFA", borderRadius: "5px", mt: 1 }}>
                  <Box
                    sx={{
                      width: `${Math.min(Math.max(safePercentage, 0), 100)}%`,
                      height: "100%",
                      backgroundColor: "#5D739E",
                      transition: "width 0.3s ease-in-out",
                    }}
                  />
                </Box>
              )}

              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
                <Typography sx={{ fontSize: "18px", fontWeight: 700, color: "#45464E", fontFamily: "Inter" }}>
                  <span>{card.rightValue}</span>
                  {/* <span className="analytics-cards-label">{card?.rightValueLabel}</span> */}
                </Typography>
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default AnalyticsCardContents;